<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import UsersList from "@/router/views/admin/users-list";
import TradersList from "@/router/views/admin/traders-list";
import ServicesList from "@/router/views/admin/services-list";
import MailMessages from "@/router/views/admin/mailMessages";
import CustomerApi from "@/services/customers-api";
import UsersApi from "@/services/users-api";
import Swal from "sweetalert2";
import i18n from "@/i18n";
import Vue from 'vue'
import ClaimApi from "@/services/claim-api";

// import {Priviliges} from "../../../privileges";
function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    
    if (parts.length === 2) {
        return parts.pop().split(';').shift();
    }
    
    return null;
}
export default {
  page: {
    title: "Gestion des abonnements",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout,UsersList,TradersList, ServicesList, MailMessages},
  data() {
    return {
      allTradersCount:0,
      allCustomersCount:0,
      allServicesCount:0,
      privileges:"",
      manualCustomerSyncInProgress: false

    };
  }, 
    mounted(){
      this.getTradersCount();

      if(this.isAdmin ){
        this.getServicesCount();
        this.getCustomersCount()
      }

    },
    computed: {
      isClaimTypeEnabled(){
        return  process.env.VUE_APP_FEATURE_CLAIM_TYPE === 'true'
      },

      isSendMailsToCustomerEnabled(){
        return  process.env.VUE_APP_FEATURE_SEND_MAIL_TO_CUSTOMER === 'true'
      },
      role() {
        return this.$cookies.get('userr') ? this.$cookies.get('userr') : 0;
      },
      permission() {
        const  storedPermissions = JSON.parse(getCookie('permission')) || [];
        return storedPermissions
      },
      isAdmin() {
        return (this.role === 1 && (this.permission && this.permission.some(pr => pr.includes('SUPPLIER_ADMIN'))));
      },

      isAgencySupplier() {
        return this.$cookies.get('iss');
      },
    },
    methods: {

      manualCustomerSync(){

        Swal.fire({
                title: i18n.t('customerSync.swal.title'),
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#f46a6a",
                cancelButtonColor: "#34c38f",
                cancelButtonText: i18n.t('customerSync.swal.cancelButtonText'),
                confirmButtonText: i18n.t('customerSync.swal.confirmButtonText'),
            }).then((result) => {
                if (result.value) {
                  CustomerApi.manualCustomerSync().then(result=>{
                    if(result){
                      Vue.prototype.$snotify.success("La synchronisation des clients est lancée");
                    }
                  })
                }
            });
    },
      getTradersCount(){
        UsersApi.getTradersCount().then(
          result => {
            if(result){
              this.allTradersCount=result;
            }else{
              this.allTradersCount=0
            }
            
          }
        )
      },
      getServicesCount(){
        ClaimApi.getServicesCount().then(
          result => {
            if(result){
              this.allServicesCount=result;
            }else{
              this.allServicesCount=0
            }
            
          }
        )
      },
      getCustomersCount(){
        CustomerApi.getCountCustomers().then(
          result => {
            if(result){
              this.allCustomersCount=result;
            }else{
              this.allCustomersCount=0
            }
            
          }
        )
      },

    }
};
</script>
<template>
  <Layout>
    <div v-if="isAdmin" class="row pt-4 p-sm-4">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class=" col-6">
                <h2 class="card-title font-size-25" style="font-size:25px;">{{$t('subscription.cardTitle')}} </h2>
                <p class="card-title-desc font-size-14">
                  <u class="mr-1"><span>{{this.allCustomersCount}}</span> {{$t('subscription.customers')}},</u> &nbsp;&nbsp; 
                  <u v-if="!isAgencySupplier"><span>{{this.allTradersCount}}</span> {{$t('subscription.traders')}}<span v-if="isClaimTypeEnabled">,&nbsp;&nbsp; </span></u> 
                  <u v-if="isClaimTypeEnabled"><span>{{this.allServicesCount}}</span> {{$t('subscription.services.services')}}</u>.
                </p>  
              </div>

              <div class=" col-6">
                <div class="float-right mb-3">
                    <b-button  title="Sync" size="md"   variant="outline-danger"  @click.prevent="manualCustomerSync()" :disabled="manualCustomerSyncInProgress"  >
                        <b-spinner small :class="manualCustomerSyncInProgress ? 'mr-1' : 'd-none'"></b-spinner>
                        <i class="fas fa-sync-alt  font-size-16  font-weight-bold align-middle  mr-0 mr-sm-2"></i>
                        <span class=" font-weight-bold text-uppercase d-none d-sm-inline">Forcer la sync des Clients</span>         
                    </b-button> 
                </div>   
              </div>
            </div>

             <b-tabs content-class="p-3 text-muted">
              <b-tab v-if="isAdmin || hasCustomerUserManagementAccess" lazy>
                  <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                      <i class="fas fa-user font-size-16"></i>
                    </span>
                    <i class="d-none d-sm-inline-block fa fa-info-circle font-size-16 pr-2"/><span class="d-none d-sm-inline-block font-size-16">{{$t('subscription.customers')}}</span>
                  </template>
                  <UsersList/>
                </b-tab>
                <b-tab v-if="!isAgencySupplier && (isAdmin || hasTradersUserManagementAccess)" lazy>
                  <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                      <i class="fas fa-user-tie font-size-16"></i>
                    </span>
                    <i class="d-none d-sm-inline-block fas fa-user-tie font-size-16 pr-2"/><span class="d-none d-sm-inline-block font-size-16">{{$t('subscription.traders')}}</span>
                  </template>
                  <TradersList/>
                </b-tab>               
                <b-tab v-if="!isAgencySupplier && isClaimTypeEnabled && ( isAdmin || hasTradersUserManagementAccess) " lazy>
                  <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                      <i class="fas fa-building font-size-16"></i>
                    </span>
                    <i class="d-none d-sm-inline-block fas fa-building font-size-16 pr-2"/><span class="d-none d-sm-inline-block font-size-16">{{$t('subscription.services.services')}}</span>
                  </template>
                  <ServicesList/>
                </b-tab>
                <b-tab v-if="!isAgencySupplier && isSendMailsToCustomerEnabled && isAdmin " lazy>
                  <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                      <i class="fas fa-mail-bulk font-size-16"></i>
                    </span>
                    <i class="d-none d-sm-inline-block fas fa-mail-bulk font-size-16 pr-2"/><span class="d-none d-sm-inline-block font-size-16">{{$t('subscription.mails')}}</span>
                  </template>
                  <MailMessages/>
                </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>

  </Layout>
</template>

